// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { initializeFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDfXi2DRJ0Z7Ge-oL9tG9vyMg52oi9MtmY",
  authDomain: "whos-visiting-316bb.firebaseapp.com",
  projectId: "whos-visiting-316bb",
  storageBucket: "whos-visiting-316bb.appspot.com",
  messagingSenderId: "201812581467",
  appId: "1:201812581467:web:ac45cd192581205af4337e",
  measurementId: "G-H41PXQXGJT",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const store = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
});
export const analytics = getAnalytics(app);
